import { motion } from 'framer-motion/dist/framer-motion';
import React from 'react';
import './SouravLogo.css';

const svgVariants = {
  hidden: {
    rotate: 0,
  },
  visible: {
    rotate: 0,
    transition: {
      duration: 3
    }
  }
}

const pathVariants = {
  hidden: {
    opacity: 1,
    pathLength: 0
  },
  visible: {
    opacity: 1,
    pathLength: 1,
    transition: {
      duration: 4,
      ease: "easeIn"
    }
  }
}


const SouravLogo = () => {
  return (

    <>


      <div className='svg-wrapper'>
        <motion.svg className="pizza-svg"
          variants={svgVariants}
          initial="hidden"
          animate="visible"

          width="0.711111in"
          height="0.455556in"
          xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 41">

          <motion.path
            id="Imported Path"
            variants={pathVariants}
            fill="none"
            stroke='#64ffda'
            strokeWidth="0.3"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M 58.08,18.49
                    C 58.36,18.33 58.73,18.24 59.20,18.24
                      60.12,18.24 60.92,18.64 61.59,19.45
                      62.26,20.25 62.60,21.26 62.60,22.48
                      62.60,25.29 61.08,27.97 58.04,30.51
                      58.04,30.51 57.83,30.36 57.83,30.36
                      57.88,30.00 57.90,29.68 57.90,29.41
                      57.90,28.32 57.22,26.82 55.85,24.91
                      55.58,25.18 55.24,25.63 54.83,26.27
                      54.83,26.27 54.02,27.49 54.02,27.49
                      54.02,27.49 53.48,27.01 53.48,27.01
                      53.69,26.74 53.96,26.32 54.30,25.76
                      54.64,25.18 54.91,24.75 55.09,24.48
                      55.70,23.64 56.06,22.77 56.18,21.86
                      56.18,21.86 56.43,21.86 56.43,21.86
                      56.54,22.47 56.94,23.28 57.62,24.27
                      58.30,25.26 58.71,26.02 58.87,26.55
                      59.03,27.07 59.11,27.57 59.11,28.04
                      59.11,28.04 59.11,28.54 59.11,28.54
                      60.96,26.62 61.88,24.59 61.88,22.44
                      61.88,21.64 61.69,21.01 61.30,20.55
                      60.92,20.07 60.42,19.84 59.80,19.84
                      59.33,19.84 58.88,19.96 58.44,20.19
                      58.20,19.70 58.08,19.13 58.08,18.49
                      58.08,18.49 58.08,18.49 58.08,18.49 Z
                    M 64.01,27.12
                    C 62.73,29.20 61.15,30.33 59.27,30.51
                      59.27,30.51 59.15,30.17 59.15,30.17
                      60.00,29.97 60.72,29.64 61.30,29.18
                      61.89,28.70 62.60,27.88 63.43,26.70
                      63.43,26.70 64.01,27.12 64.01,27.12 Z
                    M 54.72,27.12
                    C 53.39,29.22 52.09,30.28 50.81,30.28
                      50.33,30.28 49.99,30.15 49.78,29.89
                      49.56,29.63 49.45,29.08 49.44,28.26
                      48.74,29.13 48.14,29.70 47.65,29.96
                      47.17,30.23 46.62,30.36 46.00,30.36
                      45.10,30.36 44.38,30.05 43.85,29.42
                      43.32,28.80 43.06,27.96 43.06,26.91
                      43.06,26.91 43.06,26.15 43.06,26.15
                      42.93,26.31 42.63,26.74 42.16,27.42
                      42.16,27.42 41.58,27.01 41.58,27.01
                      42.61,25.41 43.69,24.15 44.83,23.24
                      45.97,22.32 46.97,21.86 47.83,21.86
                      48.44,21.86 49.04,22.04 49.63,22.41
                      49.63,22.41 51.18,21.61 51.18,21.61
                      51.18,21.61 51.18,27.63 51.18,27.63
                      51.18,28.27 51.21,28.66 51.27,28.79
                      51.33,28.92 51.48,28.98 51.74,28.98
                      51.96,28.98 52.30,28.78 52.74,28.38
                      53.18,27.98 53.67,27.40 54.20,26.66
                      54.20,26.66 54.72,27.12 54.72,27.12 Z
                    M 48.88,26.45
                    C 48.88,26.45 48.88,22.89 48.88,22.89
                      48.41,22.40 47.85,22.16 47.20,22.16
                      46.49,22.16 45.86,22.49 45.30,23.15
                      44.74,23.81 44.46,24.63 44.46,25.61
                      44.46,26.47 44.66,27.13 45.06,27.60
                      45.45,28.06 46.00,28.29 46.69,28.29
                      47.23,28.29 47.72,28.02 48.18,27.49
                      48.65,26.95 48.88,26.60 48.88,26.45
                      48.88,26.45 48.88,26.45 48.88,26.45 Z
                    M 42.32,27.12
                    C 41.00,29.22 39.67,30.28 38.34,30.28
                      36.97,30.28 36.28,29.49 36.28,27.92
                      36.28,26.64 36.89,25.25 38.09,23.75
                      37.88,23.80 37.51,23.82 36.97,23.82
                      36.62,23.82 36.25,23.75 35.86,23.61
                      35.27,24.92 34.48,26.21 33.49,27.46
                      33.49,27.46 32.95,27.01 32.95,27.01
                      34.05,25.41 35.01,23.58 35.83,21.54
                      36.95,22.07 37.83,22.34 38.48,22.34
                      39.08,22.34 39.61,22.09 40.06,21.61
                      40.06,21.61 40.35,21.82 40.35,21.82
                      39.64,22.72 39.07,23.63 38.63,24.55
                      38.20,25.46 37.99,26.47 37.99,27.56
                      37.99,27.91 38.10,28.23 38.32,28.54
                      38.54,28.83 38.79,28.98 39.06,28.98
                      39.50,28.98 39.93,28.80 40.34,28.43
                      40.75,28.07 41.23,27.49 41.79,26.70
                      41.79,26.70 42.32,27.12 42.32,27.12 Z
                    M 33.72,27.12
                    C 32.31,29.22 30.96,30.28 29.67,30.28
                      29.24,30.28 28.90,30.13 28.67,29.85
                      28.45,29.55 28.34,28.92 28.34,27.95
                      28.34,27.95 28.34,26.47 28.34,26.47
                      27.07,28.34 26.18,29.48 25.67,29.87
                      25.15,30.25 24.67,30.43 24.21,30.43
                      23.73,30.43 23.36,30.27 23.09,29.94
                      22.83,29.61 22.70,28.84 22.70,27.63
                      22.70,27.63 22.70,24.73 22.70,24.73
                      22.20,25.86 21.69,26.76 21.16,27.42
                      21.16,27.42 20.58,27.01 20.58,27.01
                      21.62,25.50 22.33,23.98 22.70,22.44
                      22.70,22.44 24.46,21.54 24.46,21.54
                      24.46,21.54 24.46,27.95 24.46,27.95
                      24.46,28.41 24.48,28.73 24.53,28.89
                      24.59,29.05 24.73,29.12 24.97,29.12
                      25.22,29.12 25.56,28.92 25.97,28.52
                      26.39,28.12 26.88,27.48 27.46,26.59
                      28.04,25.70 28.34,25.22 28.34,25.14
                      28.34,25.14 28.34,22.44 28.34,22.44
                      28.34,22.44 30.11,21.54 30.11,21.54
                      30.11,21.54 30.11,27.09 30.11,27.09
                      30.11,27.82 30.13,28.32 30.18,28.59
                      30.24,28.85 30.39,28.98 30.63,28.98
                      31.21,28.98 32.06,28.21 33.20,26.66
                      33.20,26.66 33.72,27.12 33.72,27.12 Z
                    M 9.30,27.01
                    C 10.82,24.83 12.06,23.42 13.04,22.78
                      14.01,22.14 15.02,21.82 16.09,21.82
                      17.11,21.82 17.90,22.09 18.47,22.64
                      19.06,23.18 19.35,23.94 19.35,24.91
                      19.35,26.29 18.80,27.55 17.70,28.70
                      16.60,29.83 15.32,30.40 13.86,30.40
                      12.91,30.40 12.15,30.12 11.58,29.55
                      11.02,28.97 10.74,28.24 10.74,27.35
                      10.74,26.88 10.77,26.45 10.84,26.08
                      10.67,26.28 10.35,26.74 9.88,27.46
                      9.88,27.46 9.30,27.01 9.30,27.01 Z
                    M 15.58,29.67
                    C 16.47,29.67 17.18,29.35 17.70,28.70
                      18.23,28.05 18.49,27.19 18.49,26.11
                      18.49,25.18 18.25,24.45 17.76,23.93
                      17.26,23.40 16.62,23.13 15.81,23.13
                      14.95,23.13 14.27,23.45 13.76,24.07
                      13.25,24.70 13.00,25.57 13.00,26.70
                      13.00,28.68 13.86,29.67 15.58,29.67
                      15.58,29.67 15.58,29.67 15.58,29.67 Z
                    M 21.91,27.56
                    C 20.98,28.91 20.09,29.80 19.26,30.24
                      18.43,30.67 17.60,30.93 16.77,31.02
                      16.77,31.02 16.05,30.17 16.05,30.17
                      17.98,29.73 19.55,28.57 20.76,26.70
                      20.76,26.70 21.91,27.56 21.91,27.56 Z
                    M 4.12,21.36
                    C 5.04,21.83 5.77,22.53 6.32,23.44
                      6.87,24.34 7.14,25.26 7.14,26.18
                      7.14,27.28 6.82,28.24 6.18,29.05
                      5.54,29.87 4.73,30.28 3.74,30.28
                      3.25,30.28 2.71,30.11 2.14,29.78
                      1.57,29.45 1.07,28.96 0.65,28.33
                      1.01,27.76 1.54,27.27 2.23,26.87
                      2.23,26.87 2.37,27.05 2.37,27.05
                      2.34,27.17 2.33,27.34 2.33,27.56
                      2.33,28.07 2.51,28.53 2.86,28.93
                      3.21,29.32 3.61,29.51 4.05,29.51
                      4.60,29.51 5.05,29.28 5.40,28.82
                      5.75,28.35 5.93,27.76 5.93,27.05
                      5.93,25.59 5.06,24.28 3.33,23.13
                      3.33,23.13 1.84,25.51 1.84,25.51
                      1.25,26.48 0.81,27.13 0.54,27.46
                      0.54,27.46 -0.00,27.01 -0.00,27.01
                      1.19,25.23 2.38,23.06 3.56,20.49
                      3.56,20.49 3.98,20.53 3.98,20.53
                      3.98,20.53 4.12,21.36 4.12,21.36 Z
                    M 9.98,26.29
                    C 8.82,28.92 7.29,30.33 5.39,30.51
                      5.39,30.51 5.28,30.17 5.28,30.17
                      6.12,29.97 6.84,29.64 7.42,29.18
                      8.02,28.70 8.74,27.88 9.60,26.70
                      9.60,26.70 9.98,26.29 9.98,26.29 Z" />

        </motion.svg>
      </div>
    </>



  )
}

export default SouravLogo